import LocalMaterial from '@/components/local-material/LocalMaterial.vue'

export default {
    components: {
        LocalMaterial
    },
    model: {
        prop: 'returnData',
        event: 'change'
    },
    props: {
        returnData: {},
        filters: {
            type: Object,
            default: ({
                type: 2, //类型：2-图片 3-视频
                num: 1, //可选数量
                ratio: null, //比例： 宽度/高度
                size: null, //大小
                url: null, //图片地址 （默认选中素材） 
                width: null, //最大宽度要求
                height: null, //最大高度要求
                fixedWidth: null, //固定宽度
                fixedHeight: null, //固定高度
                isBatchSelect: false, //是否批量选择
                need_sync_juliang: false, //是否需要同步聚量
            })
        },
        onlyUrl: { //是否只返回地址
            type: Boolean,
            default: () => false
        },
        simpleMode: { //简单模式，为true时，只显示卡片名称
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            loading: false,
            previewVisible: false,
            previewImage: null,
            fileList: [],
            showLocalMaterialForm: false,
            material: {},
            materials: [],
        }
    },
    mounted() {
        if (typeof this.returnData === 'object') {
            this.material = Object.assign({}, this.returnData)
            if (Array.isArray(this.returnData)) {
                this.materials = this.returnData
            }
        } else {
            if (this.filters.url) {
                if (this.filters.isBatchSelect) {
                    let urls = []
                    this.filters.url.forEach(url => {
                        urls.push({file_url:url})
                    });
                    this.material = this.materials  = urls
                } else {
                    this.material = {
                        file_url: this.filters.url
                    }
                }
            } else if (typeof this.returnData === 'string') {
                this.material = {
                    file_url: this.returnData
                }
            }
        }

        // console.log('this.materials', this.materials)
    },
    methods: {
        preview (item) {
            if (item) {
                this.previewImage = item.file_url
            } else {
                this.previewImage = this.material.file_url
            }
        },
        closerPreviewImage () {
            this.previewImage = null
        },
        deleteImage(item) {
            this.$emit('delete')
            if (item.file_url) {
                this.materials = this.materials.filter((material) => material.file_url !== item.file_url);
                this.syncMaterial()
            } else {
                this.material = {}
                this.syncMaterial()
            }
        },
        clearSelectMaterials () {
            this.materials = []
            // 调用子组件方法，清空内部选中状态
            if (this.$refs.localMaterial) {
                this.$refs.localMaterial.clearSelected()
            }
            this.syncMaterial()
        },
        handleCancel() {
            this.previewVisible = false
        },
        buttonClick() {
            // console.log('点击了打开本地素材按钮')
            this.showLocalMaterialForm = true
        },
        close() {
            this.showLocalMaterialForm = false
            this.$nextTick(() => {
                // 禁用右键
                document.oncontextmenu = new Function('event.returnValue=true')
            })
        },
        afterCloseLocalMaterialList(item) {
            // console.log('关闭了本地素材列表，选中的素材是：', item)
            if (this.filters.isBatchSelect) {
                this.materials = item
            } else {
                this.material = item
            }
            // console.log('当前选中的素材是:', this.material,this.materials)
            this.showLocalMaterialForm = false
            this.syncMaterial()
        },
        syncMaterial () {
             //同步父组件
            if (this.filters.isBatchSelect) {
                //当前是批量选择
                if (this.onlyUrl) {
                    let urls = []
                    this.materials.forEach(element => {
                        urls.push(element.file_url)
                    });
                    this.$emit('change', this.urls)
                } else {
                    this.$emit('change', this.materials)
                }
            } else {
                this.$emit('change', this.onlyUrl ? this.material.file_url : this.material)
            }
        },
    }
}
